<template>
  <div>
    <div>
      <div class="d-flex topbar">
        <nav aria-label="breadcrumb" class="mr-auto">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{name: 'SearchList'}">Mes Recherches</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name: 'SearchDetails', params: {id: searchId}}">Recherche</router-link>
            </li>
            <li class="breadcrumb-item active d-none d-sm-block" aria-current="page">Requêtes</li>
          </ol>
        </nav>

        <div class="dropdown expand-md">
          <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="icon fa fa-cogs"></i>
          </button>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <router-link class="dropdown-item" :to="{name: 'SearchMembers', params: {id: searchId}}">
              <i class="icon fa fa-users"></i> Utilisateurs
            </router-link>
          </div>
        </div>

        <ul class="nav ml-auto collapse-md">
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'SearchMembers', params: {id: searchId}}">
              <i class="icon fa fa-users"></i> Utilisateurs
            </router-link>
          </li>
        </ul>
      </div>

      <div class="jumbotron">
        <h1>Gérer les requêtes</h1>
        <h4>Vous pouvez associer une ou plusieurs requêtes à votre recherche.</h4>
      </div>
    </div>

    <div class="container">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th>Nom de la requête</th>
            <!-- <th>Items</th> -->
            <!-- <th>Edit</th> -->
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="searchQuery in searchQueries" :key="searchQuery.externalSourceQueryId">
            <td>{{searchQuery.queryName}}</td>
            <!-- <td>0</td> -->
            <!-- <td></td> -->
            <td>
              <router-link
                :to="{name: 'SearchQueryUpdate', params: {searchId: searchQuery.searchId, queryId: searchQuery.externalSourceQueryId}}"
              ><i class="icon fa fa-pen"></i></router-link>
              &nbsp;&nbsp;
              <button class="btn btn-secondary" @click="deleteQuery(searchQuery)"><i class="icon fa fa-trash"></i></button>
            </td>
          </tr>
        </tbody>
      </table>

      <router-link href="#" :to="{name: 'SearchQueryAdd', params: {searchId: searchId}}">
        <span class="btn btn-primary btn-xl">Ajouter une autre requête</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SearchQueries",
  props: ["id"],
  searchQueries: [],
  searchId: 0,
  search: {},
  data() {
    return {
      search: {},
      searchQueries: []
    };
  },
  mounted() {
    var tempQueries = {};

    var vm = this;

    this.searchId = this.$route.params.id;

    axios
      .get(
        process.env.BACKEND_URL +
          "/api/searches/" +
          this.$route.params.id +
          "/queries"
      )
      .then(response => {
        vm.searchQueries = response.data;
      });
  },
  methods: {
    deleteQuery: function(searchQuery) {
      var vm = this;

      var queryIndex = vm.searchQueries.indexOf(searchQuery);

      axios
        .delete(
          process.env.BACKEND_URL +
            "/api/searches/" +
            vm.searchId +
            "/queries/" +
            searchQuery.externalSourceQueryId
        )
        .then(response => {
          vm.searchQueries.splice(queryIndex, 1);
        });

      return false;
    }
  }
};
</script>

<style>
.jumbotron{
  margin-top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/queries/SearchQueries.vue